import { useContext, useEffect, useState } from 'react';
import { LinearProgress, Tooltip } from '@mui/material';
import { progressBarConstants } from '@/Config/constantValues';
import { LocalizationContext } from '@context/LocalizationContext';

interface IProgressBarProps {
	progressPercentage: number;
}

const progressBarStyle = {
	borderRadius: 5,
};

export default function ProgressBarComponent(props: IProgressBarProps) {
	const [progress, setProgress] = useState(progressBarConstants.welcomeScreen); // Initial value of progress bar

	const { ProgressBar } = useContext(LocalizationContext);

	useEffect(() => {
		if (props.progressPercentage) {
			if (props.progressPercentage === progressBarConstants.welcomeScreen) {
				setProgress(progressBarConstants.welcomeScreen);
			} else if (props.progressPercentage >= progressBarConstants.questionnaireEnd) {
				setProgress(progressBarConstants.questionnaireEnd);
			} else if (props.progressPercentage === progressBarConstants.firstQuestionStart) {
				setProgress(props.progressPercentage);
			} else {
				setProgress(
					(props.progressPercentage / 100) * (100 - progressBarConstants.firstQuestionStart) +
						progressBarConstants.firstQuestionStart,
				);
			}
		}
	}, [props.progressPercentage]);

	return (
		<Tooltip
			title={
				progress < progressBarConstants.questionnaireEnd ? Math.round(progress) + '%' : ProgressBar.Completed
			}
			placement="top"
			followCursor={true}>
			<LinearProgress
				color={'primary'}
				data-cy={'pqProgressBar'}
				variant={'determinate'}
				value={progress}
				sx={progressBarStyle}
			/>
		</Tooltip>
	);
}
